export default __webpack_public_path__ + "static/media/waiting_for_price.26ce7839.svg";